/* eslint-disable max-len */
import React from "react";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { AxiosError, AxiosResponse } from "axios";
import {
  OwnersForAdditionalInformation,
  OwnershipInformationdata,
} from "./ownershipForm/OwnershipInformationdata";
import OwnershipQuestionnarieForm from "./ownershipForm/OwnershipQuestionnarieForm";
import OwnersList from "./duplicateOwnners/OwnersList";
import { BankUserContext } from "../../../../bankUserContext";
import OwnershipInformationMainCC from "./OwnershipInformation/OwnershipMainCC";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import checkedPlane from "../../../../images/checkedPlane.svg";
import flagPlane from "../../../../images/flagPlane.svg";
import redFlag from "../../../../images/red-flag.svg";
import writingredFlag from "../../../../images/writingredFlag.svg";
import checked from "../../../../images/approvechecked.svg";
import writing from "../../../../images/writing.svg";
import history from "../../../../images/history.svg";
import message from "../../../../images/message.svg";
import help from "../../../../images/help.svg";
import cross from "../../../../images/x.svg";
import comment from "../../../../images/comment.svg";
import oval from "../../../../Images/Oval.svg";
import CheckOval from "../../../../Images/checkOval.svg";
import copyImage from "../../../../Images/copy.svg";
import check from "../../../../images/check.svg";
import { toast } from "react-toastify";
import { Modal } from "reactstrap";
import { ModalHeader } from "reactstrap";
import { ModalBody } from "reactstrap";
import { Button } from "reactstrap";
import backGray from "../../../../images/backGray.svg";
import { Collapse } from "reactstrap";
import moment from "moment";
import Service from "../../../../services";
import { HistoryInfo, Question, saveQuestionReview } from "../../../../models/ComplianeQuestionarie";
import { catchError } from "../../../../utils/Utils";
import FlaggReasonForm from "../../Questionarie/FlaggReasonForm";
import MessageChatWindowFC from "../../../MessageCenter/QuestionarieMC/MessageChatWindowFC";
import { MessageThread, MessageThreadImpl } from "../../../../models/QuestionarieMCModal";
interface OwnershipQuestionnarieProps {
  currentQuestions?: any;
  clientProductId?: any;
  clientId: any;
  complianceMode: boolean;
  status?: string;
  questionsData: Array<Question>;
  postsavequestion?: any;
  refreshQuestionsData?: boolean;
  loader: boolean;
  setLoader: React.Dispatch<React.SetStateAction<boolean>> | ((value: boolean) => void);
  match: any;
  onClickMessageCenter: Function;
  onClickHistory: Function;
  onClickGuidance: Function;
  disableActions: boolean;

}

interface OwnershipQuestionnarieState {
  questionsCompleted: boolean;
  currentQuestions: any[];
  formInitialvalues: any;
  OwnersInformation: any[];
  OwnersInformation2: any;
  individualsData: OwnershipInformationdata[];
  clientStockData: any;
  entityType: any;
  OwnershipInformationdata: any;
  clientDetails: any;
  clientUserId: string;
  selectedMessageThread: MessageThread;
  messageModal: boolean;
  selectedQuestion: any;
  refreshCounter: number;
  flagModal: boolean;
  flaggedQuestion: any;
  isEditFlagNotes: boolean;
  notesForm: Array<any>;
  textAreaNotes: string;
  guidance: Array<any>;
  guidanceModal: boolean;
  guidanceToggle: number;
  questionHistory: Array<any>;
  historyModal: boolean;
  match: any;
}

class OwnershipQuestionnaireComponent extends React.Component<
  OwnershipQuestionnarieProps,
  OwnershipQuestionnarieState
> {
  OwnersInformation: any;
  service = new Service();
  //roles = new RolesAuthentication();
  static contextType = BankUserContext;


  constructor(props: OwnershipQuestionnarieProps) {
    super(props);
    this.state = {
      questionsCompleted: false,
      currentQuestions: [],
      formInitialvalues: {},
      entityType: {},
      match: "",

      OwnersInformation2: {},
      OwnersInformation: [
        {
          identities: [
            { name: "John Kowalski", value: 1234, isPrimary: true },
            { name: "John Kowalski", value: 1234, isPrimary: false },
            { name: "John Kowalski", value: 1234, isPrimary: false },
          ],
          OwnershipPercentage: "24%",
          isCompeleted: true,
        },
        {
          identities: [{ name: "John Kowalski", value: 1234, isPrimary: true }],
          OwnershipPercentage: "24%",
          isCompeleted: false,
        },
      ],
      individualsData: [],
      clientStockData: "no",
      OwnershipInformationdata: {},
      clientDetails: {},
      clientUserId: "0",
      // selectedMessageThread: new MessageThreadImpl(),
      messageModal: false,
      selectedQuestion: {},
      refreshCounter: 0,
      isEditFlagNotes: false,
      flaggedQuestion: {},
      flagModal: false,
      notesForm: [],
      textAreaNotes: "",
      guidance: [],
      guidanceModal: false,
      guidanceToggle: 0,
      questionHistory: [],
      historyModal: false,
      selectedMessageThread: new MessageThreadImpl(),
    };
  }

  getIndividuals = () => {
    const clientProductId = this.props?.clientProductId;

    this.service
      .getOwnersOfTypeIndividuals(clientProductId)
      .then((res: AxiosResponse<OwnershipInformationdata[]>) => {
        this.setState({ individualsData: res.data });
      })
      .catch((error: AxiosError) => {
        // console.log(error);
      });
  };

  // Check in OwnershipQuestionaryForm (DEVI)
  getStockSymbol = () => {
    // const clientProductId = this.props?.clientProductId;
    const clientProductId = this.props?.clientProductId;
    this.props?.setLoader(true)
    this.service
      .getStockSymbol(clientProductId)
      .then((response: any) => {
        this.props?.setLoader(false);
        this.setState({ clientStockData: response?.data });
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  postSaveStockSymbol = (yesOrNo?: string) => {
    const postData = {
      ...this.state.clientStockData,
      duplicateIndividuals: yesOrNo,
      clientProductsId: this.props?.clientProductId,
    };
    this.service.postSaveStockSymbol(postData).then(() => {
      this.getStockSymbol();
    });
  };

  getAllOwnershipContacts = () => {
    const clientProductId = this.props?.clientProductId;
    this.props?.setLoader(true)
    this.service
      .getOwnersForAdditionalInformation(clientProductId)
      .then((response: AxiosResponse<OwnersForAdditionalInformation[]>) => {
        const owners = response?.data || [];
        this.setState({ OwnersInformation: owners });
        this.props?.setLoader(false)
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        this.props?.setLoader(false);
      });
  };
  getWelcomeQuestion = () => {
    const clientProductId = this.props?.clientProductId;
    false &&
      this.service.getFirstQuestion(clientProductId).then((response: any) => {
        if (response.data) {
          const answer = response.data?.answers[0]?.optionId;

          const entityType = response.data.options.find(
            (m: any) => m.value === answer
          );

          this.setState({
            entityType,
          });
        }
      });
  };

  componentDidMount() {
    this.getIndividuals();
    this.getAllOwnershipContacts();
    this.getStockSymbol();
    this.getWelcomeQuestion();
    this.getClientDetails();
  }

  getClientDetails = () => {
    this.service.getUserIdByClientId(this.props?.clientProductId).then(resp => {
      this.setState({ clientUserId: resp?.data?.userId });
    }).catch((error: AxiosError) => {
      catchError(error, true);
    })
  };

  statusChange = (question: Question) => {
    if (this.props.disableActions) {
      return false;
    } else if (question.naFlag) {
      return false;
    } else {
      return true;
    }
  };

  onAccept = (question: Question) => {
    if (this.statusChange(question)) {
      const body: saveQuestionReview = {
        accepted: !question.reviewAccepted,
        flagged: question.reviewFlagged,
        items: [],
        notes: question.reviewNotes,
        infoId: 1,
        flaggedReason: question.flaggedReason,
        naReason: question.naReason,
        naFlag: question.naFlag,
      };
      body.items = [
        {
          clientQuestionId: question.clientQuestionId,
          reviewClientQuestionId: question.reviewClientQuestionId,
        },
      ];

      this.props.postsavequestion(body);
    }
  };

  Flagtoggle = (question: Question, isEdit: boolean) => {
    if (this.statusChange(question)) {
      this.setState({
        flaggedQuestion: question,
        isEditFlagNotes: isEdit,
        flagModal: !this.state.flagModal,
      });
    }
  };

  onFlagged = (question: Question) => {
    if (this.statusChange(question)) {
      const body: saveQuestionReview = {
        accepted: question.reviewAccepted,
        flagged: !question.reviewFlagged,
        items: [],
        notes: question.reviewNotes,
        infoId: 2,
        flaggedReason: question.flaggedReason,
        naReason: question.naReason,
        naFlag: question.naFlag,
      };
      if (question.complianceGroupId) {
        this.props.questionsData
          .filter(
            (m: Question) =>
              m.complianceGroupId == question.complianceGroupId &&
              m.serialNumber == question.serialNumber
          )
          .map(
            (m: Question) =>
            (body.items = [
              ...body.items,
              {
                clientQuestionId: m.clientQuestionId && m.clientQuestionId,
                reviewClientQuestionId: m.reviewClientQuestionId,
              },
            ])
          );
      } else {
        body.items = [
          {
            clientQuestionId: question.clientQuestionId,
            reviewClientQuestionId: question.reviewClientQuestionId,
          },
        ];
      }
      this.props.postsavequestion(body);
    }
  };

  getQuestionThread = (clientQuestionId: any, cf?: string) => {
    const mt = new MessageThreadImpl();
    cf && this.setState({ selectedMessageThread: mt });
    this.service
      .getMessageThreadsByQuestionId(this.state.clientUserId, clientQuestionId)
      .then((resp) => {
        /**
         * Checking whether question is having message thread or not
         */
        if (resp && resp.data) {
          // setSelectedMessageThread(resp.data);
          this.setState({ selectedMessageThread: resp.data });
        }
      })
      .catch((err: any) => {
        cf && this.setState({ selectedMessageThread: mt });
      });
  };

  sendMsg = (question: Question) => {
    const context = this.context;
    const clientDeatils = this.state.clientDetails;
    // if (this.statusChange(question)) {
    //   const data = {
    //     messages: "",
    //     contextPurpose: "",
    //     subject: question?.complianceGroupName
    //       ? question?.complianceGroupName
    //       : question?.questionText,
    //     clientName: clientDeatils?.firstName
    //       ? clientDeatils?.firstName + " " + clientDeatils?.lastName
    //       : "",
    //     clientCompany: clientDeatils?.company || "",
    //     createdBy: context?.bankuserDetails?.userId,
    //     sentTo: this.state.clientUserId, //clientDeatils?.clientId || 0,
    //     message: "",
    //     id: "",
    //     createdAt: "",
    //     readFlag: false,
    //     archiveFlag: false,
    //     pinnedFlag: false,
    //     clientId: clientDeatils?.clientId,
    //   };
    //   // setSelectedMessageThread(data);
    //   // setSelectedQuestion(question);
    //   this.getQuestionThread(question.clientQuestionId);
    //   // setMessageModal(true);
    //   this.setState({
    //     messageModal: true,
    //     selectedMessageThread: data,
    //     selectedQuestion: question,
    //   });
    // }
  };

  readNotification = () => {
    // this.state.selectedMessageThread?.id &&
    //   this.service
    //     .readNotificationById(this.state.selectedMessageThread?.id, true, true,false)
    //     .catch((err:any) => catchError(err, true));
  };

  toggle = () => {
    if (this.state.messageModal) {
      this.readNotification();
    }
    // setMessageModal(!messageModal);
    this.setState({ messageModal: !this.state.messageModal });
  };

  messageSend = () => {
    // const _refreshCounter = this.state.refreshCounter + 1;
    // if (!this.state.selectedMessageThread.id) {
    //   this.getQuestionThread(this.state.selectedQuestion?.clientQuestionId);
    // } else {
    //   this.setState({ refreshCounter: _refreshCounter });
    // }
  };
  setNotesFrame = (question: Question) => {
    if (this.statusChange(question)) {
      const notes = [...this.state.notesForm];
      if (!this.state.notesForm.includes(question.clientQuestionId)) {
        notes.push(question.clientQuestionId);
        if (question.reviewNotes)
          this.setState({
            notesForm: notes,
            textAreaNotes: question.reviewNotes,
          });
        else this.setState({ notesForm: notes });
      }
    }
  };

  closeGuidanceModelHandler = () => {
    this.setState({ guidanceModal: false });
  };

  setIsOpen = (index: number) => {
    if (index == this.state.guidanceToggle) {
      this.setState({ guidanceToggle: -1 });
    } else {
      // setGuidanceToggle(index);
      this.setState({ guidanceToggle: index });
    }
  };

  getGuidance = (question: Question) => {
    let idList: any = [];
    if (question.complianceGroupId) {
      this.props.questionsData
        .filter(
          (m: Question) =>
            m.complianceGroupId == question.complianceGroupId &&
            m.serialNumber == question.serialNumber
        )
        .map((m: Question) => (idList = [...idList, m.questionId]));
    } else {
      idList = [question.questionId];
    }
    this.service
      .getQuestionGuidance({ questionId: idList })
      .then((response: any) => {
        // setGuidance(response.data)
        // setGuidanceModel(true)
        this.setState({ guidance: response.data, guidanceModal: true });
      });
  };

  flagModalViewHandler = () => {
    // setFlagModal(!flagModal)
    this.setState({ flagModal: !this.state.flagModal });
  };

  selectOptions = (question: Question) => {

    return (
      <div className="selectOptions">
        <div className="optionDisplay">
          {question.reviewAccepted !== true && (
            <div
              className={`${this.statusChange(question) ? "ChangecontainerPointer" : "containerCursor"}`}
              onClick={() => this.onAccept(question)}
            >
              <img src={checkedPlane} alt="" /> <span>Accept</span>
            </div>
          )}
          {question.reviewAccepted === true && (
            <div
              className={`${this.statusChange(question) ? "containerPointer" : "containerCursor"}`}
              onClick={() => this.onAccept(question)}
            >
              <img src={checked} alt="" /> <span>Accepted</span>
            </div>
          )}
          {question.reviewFlagged !== true && (
            <div
              className={`${this.statusChange(question) ? "containerPointer" : "containerCursor"}`}
              onClick={() => this.Flagtoggle(question, false)}
            >
              <img src={flagPlane} alt="" /> <span> Flag </span>
            </div>
          )}
          {question.reviewFlagged === true && (
            <div
              className={`${this.statusChange(question) ? "containerPointer" : "containerCursor"}`}
              onClick={() => this.onFlagged(question)}
            >
              <img src={redFlag} alt="" /> <span> Flagged </span>
            </div>
          )}
          <div
            className="containerPointer"
            onClick={() => this.props?.onClickMessageCenter(question)}
          >
            <img src={message} alt="" /> <span> Send Msg </span>
          </div>
          <div
            className={`${this.statusChange(question) ? "containerPointer" : "containerCursor"}`}
            onClick={() => this.setNotesFrame(question)}
          >
            <img src={writing} alt="" /> <span> Add Notes</span>
          </div>
        </div>
        <div
          className="bottom containerPointer"
          onClick={() => this.getGuidance(question)}
        >
          <img src={help} alt="" /> <span> Guidance </span>
        </div>
      </div>
    );
  };

  closeFrame = (question: Question) => {
    const notes = [...this.state.notesForm];
    // notes = [];

    if (this.state.notesForm.includes(question.clientQuestionId)) {
      const id = notes.indexOf(question.clientQuestionId);
      notes.splice(id, 1);
    } else {
      //notes.push(question.clientQuestionId)
    }
    this.setState({ notesForm: notes });
  };

  onAddNotes = (question: Question) => {
    if (this.statusChange(question)) {
      const notes = this.state.textAreaNotes;
      const body: saveQuestionReview = {
        accepted: question.reviewAccepted,
        flagged: question.reviewFlagged,
        notes: notes,
        infoId: 3,
        items: [],
        flaggedReason: question.flaggedReason,
        naReason: question.naReason,
        naFlag: question.naFlag,
      };

      if (question.complianceGroupId) {
        this.props.questionsData
          .filter(
            (m: Question) =>
              m.complianceGroupId == question.complianceGroupId &&
              m.serialNumber == question.serialNumber
          )
          .map(
            (m: Question) =>
            (body.items = [
              ...body.items,
              {
                clientQuestionId: m.clientQuestionId,
                reviewClientQuestionId: m.reviewClientQuestionId,
              },
            ])
          );
      } else {
        body.items = [
          {
            clientQuestionId: question.clientQuestionId,
            reviewClientQuestionId: question.reviewClientQuestionId,
          },
        ];
      }
      this.props.postsavequestion(body);
      this.closeFrame(question);
    }
  };

  notesFrame = (question: Question) => {
    return (
      <form>
        <Row>
          <Col md="10">
            <Row>
              <Col md="12">
                <span>Notes:</span>
              </Col>
              <Col className="editNotesArea">
                <textarea
                  value={this.state.textAreaNotes}
                  onChange={(e) =>
                    this.setState({ textAreaNotes: e.target.value })
                  }
                />
              </Col>
            </Row>
          </Col>
          <Col md="2" className="close">
            <Row>
              <Col md="12" className="cross">
                <img src={cross} onClick={() => this.closeFrame(question)} alt="" />
              </Col>
              <Col className="saveButton">
                <Button type="button" onClick={() => this.onAddNotes(question)}>
                  Save
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </form>
    );
  };

  guidanceModelHandler = () => {
    this.setState({ guidanceModal: !this.state.guidanceModal });
  };

  historyModalViewHandler = () => {
    this.setState({ historyModal: !this.state.historyModal });
  };

  getHistory = (reviewClientQuestionId: any, clientQuestionId: any) => {
    clientQuestionId && this.getQuestionThread(clientQuestionId, 'history');
    if (reviewClientQuestionId !== null) {
      this.service
        .getIteamHistory(reviewClientQuestionId)
        .then((response: AxiosResponse<Array<HistoryInfo>>) => {
          this.setState({ questionHistory: response.data })
        });
    }
    else {
      this.setState({ questionHistory: [] })
      // toast.error("No history found")
    }
    this.historyModalViewHandler();
  }

  render() {
    return (
      <>
        <div className="questionaryWrap">
          <p className="subTitle">
            {" "}
            Please complete the following items. Your progress will be
            auto-saved as you complete each item. You can stop and come back at
            any time.
          </p>
          <div className="addNotes">
            {!this.state.notesForm.includes(
              this.props.questionsData[0]?.clientQuestionId
            ) ? (
              <>
                {" "}
                {this.props.questionsData[0].reviewNotes &&
                  this.props.questionsData[0].reviewNotes?.length > 0 ? (

                  <Row className="notesShowReview">
                    <div className="show">
                      <span className="head">Notes:</span> &nbsp;&nbsp;&nbsp;
                      <span className="content">
                        {this.props.questionsData[0].reviewNotes}
                      </span>
                    </div>
                  </Row>



                ) : (
                  ""
                )}
              </>
            ) : (

              <Row className="notes">
                <Col>{this.notesFrame(this.props.questionsData[0])}</Col>

              </Row>
            )}
          </div>
          <div
            className={`${this.props.complianceMode ? "field" : "readOnlyMode"} ${this.props.questionsData[0].reviewFlagged
              ? "fieldFlagRed mb-3"
              : ""
              }`}
          >
            <Container>
              <Row>
                <Col md={`${this.props.complianceMode ? "10" : "12"}`}>
                  {this.props.complianceMode && <div className="displayDesitions">
                    {this.props.questionsData[0].reviewAccepted && (
                      <div>
                        <img src={check} />
                      </div>
                    )}
                    {this.props.questionsData[0].reviewFlagged &&
                      this.props.questionsData[0].flaggedReason && (
                        <div>
                          <img src={redFlag} />
                          <div
                            className="reasonFlagNote"
                            onClick={() =>
                              this.Flagtoggle(this.props.questionsData[0], true)
                            }
                          >
                            <img
                              src={writingredFlag}
                              className="reasonFlagicon"
                            />
                            <span>
                              {this.props.questionsData[0]?.flaggedReason
                                .length > 600
                                ? `${this.props.questionsData[0]?.flaggedReason.slice(
                                  0,
                                  600
                                )}...`
                                : this.props.questionsData[0]?.flaggedReason}
                            </span>
                          </div>
                        </div>
                      )}
                    {this.props.questionsData[0].naFlag && (
                      <div className="n-aDiv">
                        <span className="n-atext">N/A</span>
                      </div>
                    )}
                  </div>}

                  {this.props.complianceMode && <div
                    className="history"
                    onClick={() => this.getHistory(this.props.questionsData[0].reviewClientQuestionId,
                      this.props.questionsData[0].clientQuestionId)}>
                    <img src={history} /><span>History</span>
                  </div>}

                  <div className={`OwnershipComponent`}>
                    <div>
                      <OwnershipQuestionnarieForm
                        getAllOwnershipContacts={this.getAllOwnershipContacts}
                        getIndividuals={this.getIndividuals}
                        entityType={this.state.entityType}
                        OwnershipInformationdata={
                          this.state.OwnershipInformationdata
                        }
                        clientId={this.props.clientId}
                        getStockSymbol = {this.getStockSymbol}
                      />
                    </div>
                    {this.state.individualsData.length > 0 && (
                      <div>
                        <DndProvider backend={HTML5Backend}>
                          <OwnersList
                            individualsData={this.state.individualsData}
                            getIndividuals={this.getIndividuals}
                            clientStockData={this.state.clientStockData}
                            postSaveStockSymbol={this.postSaveStockSymbol}
                            getAllOwnershipContacts={
                              this.getAllOwnershipContacts

                            }

                          />
                        </DndProvider>
                      </div>
                    )}
                    <div>
                      <OwnershipInformationMainCC
                        OwnersInformation={this.state.OwnersInformation}
                        getAllOwnershipContacts={this.getAllOwnershipContacts}
                        entityType={this.state.entityType}
                        clientStockData={this.state.clientStockData}
                        clientDetails={this.state.clientDetails}
                      />
                    </div>
                  </div>
                </Col>
                {this.props.complianceMode && <Col md="2" className="compliance">
                  {this.selectOptions(this.props.questionsData[0])}
                </Col>}
              </Row>
            </Container>
          </div>
        </div>
        {/* <div className="addNotes">
          {!this.state.notesForm.includes(
            this.props.questionsData[0]?.clientQuestionId
          ) ? (
            <>
              {" "}
              {this.props.questionsData[0].reviewNotes &&
              this.props.questionsData[0].reviewNotes?.length > 0 ? (
                <Row className="notesShowReview">
                  <div className="show">
                    <span className="head">Notes:</span> &nbsp;&nbsp;&nbsp;
                    <span className="content">
                      {this.props.questionsData[0].reviewNotes}
                    </span>
                  </div>
                </Row>
              ) : (
                ""
              )}
            </>
          ) : (
            <Row className="notes">
              <Col>{this.notesFrame(this.props.questionsData[0])}</Col>
            </Row>
          )}
        </div> */}

        <Modal
          className="flag-modal"
          isOpen={this.state.flagModal}
          fade={false}
        // toggle={this.Flagtoggle}
        >
          <ModalHeader toggle={this.flagModalViewHandler}>
            <div>
              <img src={redFlag} />{" "}
              <span className="flagItemHeader"> Flag Item </span>
            </div>
          </ModalHeader>
          <ModalBody className="flagg-modal-container">
            <FlaggReasonForm
              toggle={this.Flagtoggle}
              flaggedQuestion={this.state.flaggedQuestion}
              label={"Reason for Flag"}
              postsavequestion={this.props.postsavequestion}
              currentQuestions={this.props.questionsData}
              flagModalViewHandler={this.flagModalViewHandler}
              isEditReason={this.state.isEditFlagNotes}
              button="Flag"
              infoId={2}
            />
          </ModalBody>
        </Modal>

        {/* <MessageCenterModal
          messageModal={this.state.messageModal}
          toggleMessageModal={this.toggle}
          refreshCounter={this.state.refreshCounter}
          messageThread={this.state.selectedMessageThread}
          messageSend={this.messageSend}
          clientDetails={this.state.clientDetails}
          clientUserId={this.state.clientUserId}
          question={this.state.selectedQuestion}
          disableforsuperuser={true}
        /> */}

        <Modal
          className="popup-modal guidanceWrapper"
          size="md"
          isOpen={this.state.guidanceModal}
          fade={false}
          toggle={this.guidanceModelHandler}
        >
          <ModalHeader
            className="guidance"
            toggle={this.closeGuidanceModelHandler}
          >
            Guidance
          </ModalHeader>
          <div>
            <div className="guidanceBody">
              {this.state.guidance &&
                this.state.guidance?.map((element: any, index: number) => (
                  <>
                    <Row>
                      <Col md="12">
                        <div
                          onClick={() => this.setIsOpen(index)}
                          className="question"
                        >
                          {index == this.state.guidanceToggle ? (
                            <img src={backGray} className="downArrow arrow" />
                          ) : (
                            <img src={backGray} className="arrow" />
                          )}
                          {this.props.questionsData[0].questionText}
                        </div>
                      </Col>
                      <Col md="12">
                        <Collapse isOpen={index == this.state.guidanceToggle}>
                          <p className="guidanceContent">{element?.guidance}</p>
                        </Collapse>
                      </Col>
                    </Row>
                  </>
                ))}
            </div>
          </div>
        </Modal>

        <Modal
          className="popup-modal modelWrap historyModal"
          size="md"
          isOpen={this.state.historyModal}
          fade={false}
          toggle={this.historyModalViewHandler}
        >
          <ModalBody>
            <button type="button" className="close" aria-label="Close"
              onClick={this.historyModalViewHandler}><span aria-hidden="true">×</span></button>
            <Tab.Container id="historyTabs" defaultActiveKey="itemHistory">
              <Row>
                <Col sm={12}>
                  <Nav variant="pills" id="historyNav" className="mb-3">
                    <Nav.Item>
                      <Nav.Link eventKey="itemHistory"><img src={history} />
                        <span>Item History</span></Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="messageHistory">
                        <img src={comment} />
                        Message History
                      </Nav.Link>
                    </Nav.Item>

                  </Nav>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <Tab.Content>
                    <Tab.Pane className="tabElement historyModalTab" eventKey="itemHistory">
                      <div>
                        <div className="historyModel">
                          {this.state.questionHistory && this.state.questionHistory[0]?.historyDTO?.length > 0 ? (
                            this.state.questionHistory !== undefined &&
                            this.state.questionHistory[0]?.historyDTO?.map((element: any, index: number) => (
                              <Row className="infoPack" key={index}>
                                <Col md="2">{element.firstName}</Col>
                                <Col md="1" className="">{moment(moment.utc(element.createdDate).toDate()).format('M/DD/YY')}</Col>
                                <Col md="2" className="timeDate">{moment(moment.utc(element.createdDate).toDate()).format('hh:mm A')}</Col>
                                <Col>{element.info}</Col>
                              </Row>
                            ))
                          ) : (
                            <Row className="infoPack">
                              <Col>No records found</Col>
                            </Row>
                          )}
                        </div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane className="tabElement historyModalTab" eventKey="messageHistory">
                      <div className="message-modal">
                        {this.state.selectedMessageThread?.messages && this.state.selectedMessageThread?.messages.length > 0 ?
                          <MessageChatWindowFC messageThread={this.state.selectedMessageThread}
                            refreshCounter={this.state.refreshCounter}></MessageChatWindowFC> :
                          <Row className="infoPack">
                            <Col>No records found</Col>
                          </Row>}
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </ModalBody>



        </Modal>
      </>
    );
  }
}
export default OwnershipQuestionnaireComponent;
